import { SECTION_SPACING_IN_REM } from "config/layout_config";
import styled from "styled-components";
import tw from "twin.macro";

export const Container = tw.div`relative`;
export const ContentWithPaddingXl = styled.div`
  padding-top: ${SECTION_SPACING_IN_REM}rem;
  ${tw`max-w-screen-xl mx-auto`}
`;
export const ContentWithPaddingLg = styled(ContentWithPaddingXl);
export const ContentWithVerticalPadding = styled.div`
  padding-top: ${SECTION_SPACING_IN_REM}rem;
`;
export const Content2Xl = tw.div`max-w-screen-2xl mx-auto`;
